import { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useLocation } from "react-router-dom";

import { Card as MuiCard, Grid, Autocomplete, TextField } from "@mui/material";
import { GridColDef, GridActionsCellItem } from "@mui/x-data-grid";
import { spacing } from "@mui/system";

import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

import OlogaDataGrid from "../../components/tables/OlogaDataGrid";
import OlogaPageHeader from "../../components/misc/OlogaPageHeader";
import { useNavigate } from "react-router";
import useLookups from "../../hooks/useLookups";

const Card = styled(MuiCard)(spacing);

function Sales() {
  const [transactionCode, setTransactionCode] = useState("");
  const [url, setUrl] = useState("");
  const { data: events } = useLookups("/events/names");
  const [eventId, setEventId] = useState(0);
  const { state } = useLocation();
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: "txId",
      headerName: "Id",
      flex: 0.6,
      editable: true,
    },
    {
      field: "event",
      headerName: "Event",
      flex: 1,
      editable: true,
    },
    {
      field: "transactionDate",
      headerName: "Transaction Date",
      flex: 1,
      editable: false,
    },
    {
      field: "merchant",
      headerName: "Merchant",
      flex: 0.6,
      editable: false,
    },
    {
      field: "paymentTypes",
      headerName: "Payment Types",
      flex: 0.7,
      editable: false,
    },
    {
      field: "totalAmount",
      headerName: "Total Amount",
      flex: 0.6,
      editable: false,
    },
    {
      field: "externalTransactionCode",
      headerName: "IQ Retail Code",
      flex: 0.6,
      editable: false,
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.5,
      editable: false,
      type: "actions",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityOutlinedIcon />}
          onClick={() => {
            navigate("/finance/saledetail", {
              state: {
                transactionCode: params.id,
                returnUrl: "/finance/sales",
                eventId: eventId,
              },
            });
          }}
          label="Details"
        />,
      ],
    },
  ];

  useEffect(() => {
    if (state && state.eventId) {
      setEventId(state.eventId);
      setUrl(`/sales/search/q?event.id=${state.eventId}`);
    }
  }, [url]);

  return (
    <>
      <OlogaPageHeader title="Sales" />
      <Grid justifyContent="space-between" container spacing={6} mb={4}>
        <Grid item xs={12} md={6}></Grid>
        <Grid item xs={12} md={6}>
          <Autocomplete
            options={events}
            getOptionLabel={(option: any) => option.name}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select the event"
                variant="outlined"
              />
            )}
            onChange={(event, value) => {
              setEventId(value?.id);
              setUrl(`/sales/search/q?event.id=${value?.id}`);
            }}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12}>
          <Card>
            <OlogaDataGrid
              url={url}
              columns={columns}
              exportToExcel={true}
              fileName="Event Sales"
              excludeFromExport={["actions"]}
            />
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

export default Sales;
